import { styled } from "styled-components";

import Button from "components/Button";
import Section from "components/Section";
import TextBlock from "components/TextBlock";
import { Container as GridContainer } from "style/components/Page";
import { styleBodyM } from "style/components/Typography";
import { MQ } from "style/mediaQueries";

export const StyledSection = styled(Section)`
    inset-block-end: 0;
    inset-inline: 0;
    position: fixed;
    z-index: 1000;
`;

export const Container = styled(GridContainer)`
    padding-block: 1.3125rem;
    padding-inline-end: 4.375rem;

    ${MQ.FROM_M} {
        padding-inline: 5.25rem;
    }

    ${MQ.FROM_XL} {
        padding-block: 1.75rem;
    }
`;

export const Content = styled(TextBlock)`
    ${MQ.FROM_M} {
        text-align: center;
    }
`;

export const LinkWrapper = styled.div`
    ${styleBodyM}

    ${MQ.FROM_M} {
        text-align: center;
    }
`;

export const CloseButton = styled(Button)`
    && {
        inset-block-start: 1.3125rem;
        inset-inline-end: 0.875rem;
        position: absolute;

        ${MQ.FROM_M} {
            inset-inline-end: 1.75rem;
        }
        ${MQ.FROM_XL} {
            inset-block-start: 1.75rem;
        }
    }
`;
